import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  handleRefresh = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'var(--bg-primary, var(--bg-color, var(--color-background-primary, #ffffff)))',
            color: 'var(--text-primary, var(--text-color, var(--color-text-primary, #212529)))',
            fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
            padding: '2rem',
            textAlign: 'center',
          }}
        >
          <p style={{ marginBottom: '1.5rem', fontSize: '1.125rem' }}>
            Something went wrong. Please refresh the page.
          </p>
          <button
            type="button"
            onClick={this.handleRefresh}
            style={{
              padding: '0.625rem 1.5rem',
              fontSize: '1rem',
              cursor: 'pointer',
              background: 'var(--button-bg, #007bff)',
              color: 'var(--button-text, #ffffff)',
              border: 'none',
              borderRadius: '4px',
            }}
          >
            Refresh
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
